<div *ngIf="validating" style="height:100px; text-align: center;">
  <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i> <br>
  <span>Validating payroll roster code ...</span>
</div>

<div *ngIf="!validating && InvalidEmployeeRosters.length === 0">
  <p-messages [severity]="messageSeverity">
    <ng-template pTemplate>
      <i class="fas fa-thumbs-up p-as-start fa-2x" *ngIf="messageSeverity === 'success'"></i>
      <i class="fas fa-exclamation-circle p-as-start fa-2x" *ngIf="messageSeverity === 'error'"></i>
      <div class="p-ml-2">
        {{message}}
        <br><br>
        To validate roster code for a different date range, please use <strong>Load Roster</strong> button.
      </div>
    </ng-template>
  </p-messages>  
</div>

<div *ngIf="InvalidEmployeeRosters.length > 0">
  <button (click)="loadData()"
          pButton type="button" 
          label="Recheck undetermined payroll roster code"
          class="p-button-rounded p-button-text p-button-primary button-icon-bold icon-large" 
          title="Click to recheck undetermined payroll roster code"
          icon="pi pi-fw pi-refresh"></button>

  <div class="p-field-checkbox">
    <p-checkbox [(ngModel)]="autoOpenEmployeeRosterForm" binary="true" inputId="binary" class="p-ml-3"></p-checkbox>
    <label for="binary">Auto open employee roster form</label>
  </div>

  <p-table [value]="InvalidEmployeeRosters" 
          selectionMode="single"
          [autoLayout]="true"
          (onRowSelect)="onRowSelect($event)"
          [(selection)]="selectedRoster"
          styleClass="p-datatable-gridlines">
    <ng-template pTemplate="caption">
      <div style="font-size: 1.2rem;color: red">
        {{InvalidEmployeeRosters.length}} invalid payroll roster codes found! 
      </div> 
      <div class="text-small form-prompt p-mt-2">
        Click on the row below to auto focus the roster cell. Then double click on the roster cell to fix the payroll roster code. <br> <br>
        Click on <button pButton pRipple class="p-button-rounded p-button-success" icon="pi-fw fas fa-wrench"></button>
         to auto fix the payroll roster code. <br>
        <strong>You must reload roster after auto fix</strong>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr *ngIf="shouldReloadRoster">
        <th colspan="6">
          <button (click)="reloadRoster()"
                  pButton type="button" 
                  label="Reload roster after taking suggested value: {{totalNumberFixed}} fixed"
                  class="p-button-rounded p-button-danger button-icon-bold icon-large" 
                  title="Click to reload roster data"
                  icon="pi pi-fw pi-refresh"></button>
        </th>
      </tr>

      <tr>
        <th>Day</th>
        <th>Employee</th>
        <th>Code</th>
        <th>Current Payroll Code</th>
        <th>Suggested Payroll Code</th>
        <th>Action</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-employeeRoster>
      <tr [pSelectableRow]="employeeRoster" style="color:red;" title="Click to select the employee's roster code">
        <td>{{employeeRoster.dayStr}}</td>
        <td>{{employeeRoster.employeeName}}</td>
        <td>{{employeeRoster.rosterCode}}</td>
        <td>{{employeeRoster.currentPayrollRosterCode?.code}}</td>
        <td>
          {{employeeRoster.suggestedPayrollRosterCode?.code}}
        </td>
        <td>
          <button pButton pRipple *ngIf="employeeRoster.canUpdatePayrollRosterCode"
                  class="p-button-rounded p-button-success"
                  title="Click to take suggested value"
                  icon="pi-fw fas fa-wrench" 
                  type="button"
                  (click)="fixPayrollRosterCode(employeeRoster)"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>